"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var statementApi = _interopRequireWildcard(require("@/api/merchantStatement"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'UnreconciledDialog',
  data: function data() {
    return {
      visible: false,
      searchForm: {
        merchantType: null,
        merchantId: null,
        maintainerId: null,
        orderStartTime: this.getPrevMonthFirstDayWithTime(),
        orderEndTime: this.getPrevMonthLastDayWithTime()
      },
      dateRange: [this.getPrevMonthFirstDayWithTime(), this.getPrevMonthLastDayWithTime()],
      pagination: {
        page: 1,
        limit: 20
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: false,
      merchantOptions: [],
      merchantLoading: false,
      maintainerOptions: []
    };
  },
  created: function created() {},
  methods: {
    getPrevMonthFirstDayWithTime: function getPrevMonthFirstDayWithTime() {
      var d = new Date();
      d.setDate(1);
      d.setHours(0, 0, 0, 0);
      d.setMonth(d.getMonth() - 1);
      var y = d.getFullYear();
      var m = String(d.getMonth() + 1).padStart(2, '0');
      return "".concat(y, "-").concat(m, "-01 00:00:00");
    },
    getPrevMonthLastDayWithTime: function getPrevMonthLastDayWithTime() {
      var d = new Date();
      d.setDate(0);
      d.setHours(23, 59, 59, 999);
      var y = d.getFullYear();
      var m = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      return "".concat(y, "-").concat(m, "-").concat(day, " 23:59:59");
    },
    open: function open() {
      this.visible = true;
      this.resetSearch();
      this.fetchList();
      this.loadMerchantsByType();
      this.loadMaintainers();
    },
    handleClosed: function handleClosed() {
      this.resetSearch();
      this.listData = {
        list: [],
        total: 0
      };
      this.merchantOptions = [];
    },
    handleMerchantTypeChange: function handleMerchantTypeChange() {
      this.searchForm.merchantId = null;
      this.merchantOptions = [];
      this.loadMerchantsByType();
    },
    handleMerchantFocus: function handleMerchantFocus() {
      if (this.merchantOptions.length === 0) {
        this.loadMerchantsByType();
      }
    },
    handleMerchantChange: function handleMerchantChange(val) {
      if (val) {
        this.handleSearch();
      }
    },
    resetSearch: function resetSearch() {
      this.searchForm = {
        merchantType: null,
        merchantId: null,
        maintainerId: null,
        orderStartTime: this.getPrevMonthFirstDayWithTime(),
        orderEndTime: this.getPrevMonthLastDayWithTime()
      };
      this.dateRange = [this.getPrevMonthFirstDayWithTime(), this.getPrevMonthLastDayWithTime()];
      this.pagination.page = 1;
      this.pagination.limit = 20;
    },
    handleSearch: function handleSearch() {
      this.pagination.page = 1;
      this.fetchList();
    },
    handleReset: function handleReset() {
      this.resetSearch();
      this.loadMerchantsByType();
      this.fetchList();
    },
    handleDateChange: function handleDateChange(val) {
      if (val && val.length === 2) {
        this.searchForm.orderStartTime = val[0];
        this.searchForm.orderEndTime = val[1];
      } else {
        this.searchForm.orderStartTime = '';
        this.searchForm.orderEndTime = '';
      }
      this.handleSearch();
    },
    handleMerchantSearch: function handleMerchantSearch(query) {
      var _this = this;
      if (!query) {
        this.merchantOptions = [];
        return;
      }
      this.merchantLoading = true;
      var type = this.searchForm.merchantType || undefined;
      statementApi.getMerchantOptionsApi(query, type).then(function (res) {
        _this.merchantOptions = (res || []).map(function (item) {
          return {
            merchantId: item.id,
            merchantName: item.supplierName
          };
        });
      }).catch(function () {
        _this.merchantOptions = [];
      }).finally(function () {
        _this.merchantLoading = false;
      });
    },
    loadMerchantsByType: function loadMerchantsByType() {
      var _this2 = this;
      var type = this.searchForm.merchantType || undefined;
      statementApi.getMerchantOptionsApi('', type).then(function (res) {
        _this2.merchantOptions = (res || []).map(function (item) {
          return {
            merchantId: item.id,
            merchantName: item.supplierName
          };
        });
      }).catch(function () {
        _this2.merchantOptions = [];
      });
    },
    loadMaintainers: function loadMaintainers() {
      var _this3 = this;
      statementApi.getSupplierMaintainerListApi().then(function (res) {
        _this3.maintainerOptions = res || [];
      }).catch(function () {
        _this3.maintainerOptions = [];
      });
    },
    fetchList: function fetchList() {
      var _this4 = this;
      this.listLoading = true;
      var params = {
        page: this.pagination.page,
        limit: this.pagination.limit,
        merchantType: this.searchForm.merchantType || undefined,
        merchantId: this.searchForm.merchantId || undefined,
        maintainerId: this.searchForm.maintainerId || undefined,
        orderStartTime: this.searchForm.orderStartTime || undefined,
        orderEndTime: this.searchForm.orderEndTime || undefined
      };
      statementApi.unreconciledMerchantListApi(params).then(function (res) {
        _this4.listData = {
          list: res && res.list ? res.list : Array.isArray(res) ? res : [],
          total: res.total || 0
        };
      }).catch(function () {
        _this4.listData = {
          list: [],
          total: 0
        };
      }).finally(function () {
        _this4.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pagination.limit = val;
      this.pagination.page = 1;
      this.fetchList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pagination.page = val;
      this.fetchList();
    },
    merchantTypeText: function merchantTypeText(val) {
      var map = {
        1: '卡券供应商',
        2: '实物供应商',
        3: '家政供应商',
        4: '核销供应商'
      };
      return map[val] || '-';
    }
  }
};